import { useTranslation as useI18NextTranslation } from 'react-i18next';

export const useTranslation = () => useI18NextTranslation();
